import { fromJS } from 'immutable'
import {
  LEAVE_REQUEST_GET_REQUEST,
  LEAVE_REQUEST_GET_SUCCESS,
  LEAVE_REQUEST_GET_FAILURE,
  LEAVE_REQUEST_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_REQUEST_GET_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_REQUEST_GET_SUCCESS:
      return state
        .set('leaveRequests', fromJS(action.payload))
        .set('isFetching', false)
    case LEAVE_REQUEST_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_REQUEST_GET_RESET:
      return state
        .delete('leaveRequests')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-request/leave-request-get-reducer.js